import React from "react";

const LatestTransactionsCard = ({LatestTransactions=[]}) => (
  <div className="card custom-card overflow-hidden">
    <div className="card-header d-flex justify-content-between align-items-center">
      <h5 className="card-title mb-0">Latest Transactions</h5>
     
    </div>
    <div className="card-body p-0 pt-1">
      <div className="table-responsive">
        <table className="table text-nowrap">
          <thead>
            <tr>
              <th>Property</th>
              <th>Price</th>
              {/* <th>Status</th> */}
            </tr>
          </thead>
          <tbody>
            {LatestTransactions.map((idx) => (
              <tr key={Math.random()}>
                <td>
                  <div className="d-flex align-items-center gap-2">
                    <div className="lh-1">
                      <span className="avatar avatar-sm">
                        <img src={idx.src} alt="" />
                      </span>
                    </div>
                    <div className="fw-medium" title={idx.product}>
                      {idx.product.length > 30
                        ? idx.product.slice(0, 30) + '...'
                        : idx.product}
                    </div>
                  </div>
                </td>
                <td>
                  <span className="fw-medium">{idx.price}</span>
                </td>
                {/* <td>
                  <span className={`badge bg-${idx.color}`}>
                    {idx.status}
                  </span>
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default LatestTransactionsCard;
